import { VaultFeatures, VaultFees } from '@/core/create';

export const VAULT_FEATURES_DEFAULT = [1, 1, 1] as VaultFeatures;
export const VAULT_FEES_DEFAULT = [0.03, 0.03, 0.03] as VaultFees;
export const VAULT_FEES_BLUECHIP = [0.015, 0.015, 0.015] as VaultFees;

/**
 * ERC721 interface
 */
export const ERC721_INTERFACE = '0x80ac58cd';

/**
 * ERC1155 interface
 */
export const ERC1155_INTERFACE = '0xd9b67a26';

/**
 * ERC165 interface
 */
export const ERC165_INTERFACE = '0x01ffc9a7';
